export default "__VITE_ASSET__47c46051__"